import React, { Component } from "react";
import { connect } from 'react-redux';
import s from "./ScaleBar.scss"; // Import CSS file
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';

const scaleValues = Array.from({ length: 10 }, (_, i) => i + 1);

class ScaleBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null,
      colors: 'normal',
      style: layoutColorStyle,
    };
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let style = layoutColorStyle;
    if (colors !== 'normal') {
      style = headerStyle;
    }
    this.setState({ colors, style });
  }

  handleClick = (value) => {
    this.setState({ selected: value });
    if (this.props.onChange) {
      this.props.onChange(value, this.props.questionId);
    }
  };

  render() {
    return (
      <div className="scale-bar">
        <span className="emoji">&#128577;</span>
        {scaleValues.map((value) => (
          <button
            key={value}
            onClick={() => this.handleClick(value)}
            className={`scale-button ${this.state.selected === value && "selected"}`}
            style={this.state.style[this.state.colors]}
          >
            {value}
          </button>
        ))}
        <span className="emoji">&#128578;</span>
      </div>
    );
  }
}


const mapState = (state) => ({
    fontSize: state.runtime.fontSize,
  });
  
export default withStyles(s)(connect(mapState)(ScaleBar));


// WEBPACK FOOTER //
// src/components/ScaleBar/ScaleBar.js